export default __webpack_public_path__ + "static/media/community-bg.eb10bb2c.png";